import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.number.to-fixed.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "addons-select"
};

var _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  viewBox: "0 0 24 24",
  fill: "none"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M19 12H5",
  stroke: "black",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M12 19L5 12L12 5",
  stroke: "black",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
})], -1);

var _hoisted_3 = [_hoisted_2];
var _hoisted_4 = {
  class: "pc-name"
};
var _hoisted_5 = {
  key: 1,
  class: "addons-dates-container"
};
var _hoisted_6 = ["onClick"];

var _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M19.5 4H5.5C4.39543 4 3.5 4.89543 3.5 6V20C3.5 21.1046 4.39543 22 5.5 22H19.5C20.6046 22 21.5 21.1046 21.5 20V6C21.5 4.89543 20.6046 4 19.5 4Z",
  stroke: "#428891",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M16.5 2V6",
  stroke: "#428891",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M8.5 2V6",
  stroke: "#428891",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M3.5 10H21.5",
  stroke: "#428891",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
})])], -1);

var _hoisted_8 = {
  class: "date-picker p-abs"
};
var _hoisted_9 = {
  key: 2,
  class: "spinner-overlay"
};
var _hoisted_10 = {
  class: "timeslots-loading-container"
};
var _hoisted_11 = {
  class: "timeslots-loading"
};
var _hoisted_12 = {
  key: 3
};
var _hoisted_13 = {
  class: "error-container"
};
var _hoisted_14 = {
  key: 0
};
var _hoisted_15 = {
  key: 1
};
var _hoisted_16 = {
  class: "price-select-wrapper"
};
var _hoisted_17 = ["src"];
var _hoisted_18 = {
  class: "price-name-wrapper"
};
var _hoisted_19 = {
  class: "price-description"
};
var _hoisted_20 = {
  class: "price-name"
};
var _hoisted_21 = {
  key: 0,
  class: "timeslot-actions"
};
var _hoisted_22 = {
  key: 0
};
var _hoisted_23 = ["onClick"];
var _hoisted_24 = ["onClick"];

var _hoisted_25 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  class: "chosen-timeslot-chevron",
  viewBox: "0 0 16 16"
}, [/*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
})], -1);

var _hoisted_26 = {
  key: 1
};
var _hoisted_27 = ["onUpdate:modelValue", "disabled"];
var _hoisted_28 = {
  key: 0,
  class: "input-error"
};
var _hoisted_29 = {
  key: 1,
  class: "input-error"
};
var _hoisted_30 = {
  key: 2,
  class: "input-error"
};
var _hoisted_31 = {
  class: "price-value"
};
var _hoisted_32 = {
  key: 4,
  class: "addons-timeslot-select price-select-wrapper"
};
var _hoisted_33 = {
  key: 0
};
var _hoisted_34 = {
  class: "key-grouping"
};
var _hoisted_35 = {
  class: "timeslots-list"
};
var _hoisted_36 = ["onClick"];
var _hoisted_37 = {
  class: "timeslot"
};
var _hoisted_38 = {
  class: "timeslot-start"
};
var _hoisted_39 = {
  class: "timeslot-price-seats"
};
var _hoisted_40 = {
  class: "seats"
};
var _hoisted_41 = {
  class: "price"
};
var _hoisted_42 = {
  key: 1,
  style: {
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "color": "gray",
    "height": "50vh"
  }
};
var _hoisted_43 = {
  style: {
    "font-size": "3rem"
  }
};
var _hoisted_44 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_form_item = _resolveComponent("el-form-item");

  var _component_el_col = _resolveComponent("el-col");

  var _component_el_row = _resolveComponent("el-row");

  var _component_el_form = _resolveComponent("el-form");

  var _component_el_date_picker = _resolveComponent("el-date-picker");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_divider = _resolveComponent("el-divider");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    title: _ctx.modalTitle,
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return _ctx.dialogVisible = $event;
    }),
    width: "80%"
  }, {
    footer: _withCtx(function () {
      return [_createElementVNode("span", _hoisted_44, [_createVNode(_component_el_button, {
        onClick: _ctx.hideDialog,
        class: "booking-button"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)];
        }),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        type: "primary",
        loading: _ctx.isLoading,
        disabled: _ctx.isDisabled,
        onClick: _ctx.addToBasketWithAddons,
        class: "booking-button"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.confirm")), 1)];
        }),
        _: 1
      }, 8, ["loading", "disabled", "onClick"])])];
    }),
    default: _withCtx(function () {
      return [_ctx.timeSlotsModalVisible ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "goback-btn",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _ctx.setShowTimeSlotsModal(false);
        })
      }, _hoisted_3)) : _createCommentVNode("", true), _createVNode(_component_el_form, {
        class: "main-pc-info"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_row, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_col, {
                span: 14
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_row, {
                    style: {
                      "margin-bottom": "1rem"
                    }
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_col, null, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, null, {
                            default: _withCtx(function () {
                              return [_createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.modalHeaderTitle), 1)];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _ctx.showAddonsDates ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAddonCalendarDays(), function (day, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["addons-date", {
            'addons-date-selected': _ctx.dayjs(_ctx.selectedDate).isSame(day, 'day')
          }]),
          onClick: function onClick($event) {
            return _ctx.selectDate(day.toDate());
          }
        }, [day.isSame(_ctx.dayjs(), 'day') ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode(_toDisplayString(_ctx.$t("select.today")), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("div", null, _toDisplayString(day.format("ddd")), 1), _createElementVNode("div", {
          style: _normalizeStyle({
            color: _ctx.dayjs(_ctx.selectedDate).isSame(day, 'day') ? 'white' : '#428891'
          })
        }, _toDisplayString(day.format("DD")), 5)], 64))], 10, _hoisted_6);
      }), 128)), _ctx.showDatePicker ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: _normalizeClass(["addons-date", {
          'addons-calendar-date-selected': _ctx.dayjs(_ctx.selectedDate).isAfter(_ctx.dayjs().add(5 - 1, 'day'), 'day')
        }]),
        onClick: _cache[2] || (_cache[2] = //@ts-ignore
        function () {
          return _ctx.openCalendar && _ctx.openCalendar.apply(_ctx, arguments);
        })
      }, [_createElementVNode("div", null, _toDisplayString(_ctx.$t("common.calendar")), 1), _hoisted_7, _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_date_picker, {
        type: "date",
        ref: "addonsDatepicker",
        "disabled-date": _ctx.isDateDisabled,
        modelValue: _ctx.selectedDate,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return _ctx.selectedDate = $event;
        }),
        onChange: _ctx.selectDate
      }, null, 8, ["disabled-date", "modelValue", "onChange"])])], 2)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _ctx.addonsLoading ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
        class: "spinner",
        loading: true
      }), _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("addons.timeslots-loading")), 1)])])) : !_ctx.timeSlotsModalVisible && _ctx.mainProductCategory && Object.keys(_ctx.groupedAddons).length && _ctx.addonsData ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_ctx.packageMaxQtyError ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t("error.max-quantity-allowed") + " " + String(_ctx.packageQuantities.maxQuantity)), 1)) : _createCommentVNode("", true), _ctx.packageMinQtyError ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.$t("error.min-quantity-allowed") + " " + String(_ctx.packageQuantities.minQuantity)), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedAddons, function (addons, ProductCategory) {
        return _openBlock(), _createElementBlock("div", {
          key: ProductCategory
        }, [_createVNode(_component_el_divider, {
          class: "price-list-divider"
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addons, function (addon, index) {
          return _openBlock(), _createElementBlock("div", {
            class: "price-selector d-flex fl-a-c",
            key: addon.id,
            ref_for: true,
            ref: "addonsRef"
          }, [_ctx.addonsData[addon.id] ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            class: "w-100"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_col, {
                span: 8,
                class: "price-name-img-wrapper"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("img", {
                    src: _ctx.productPicture(_ctx.addonsData[addon.id].pc),
                    style: {
                      "border-radius": "0.25rem"
                    }
                  }, null, 8, _hoisted_17), _createElementVNode("div", _hoisted_18, [_createElementVNode("p", _hoisted_19, _toDisplayString(addon.isMandatory ? _ctx.$t("addons.mandatory") : ""), 1), _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.priceName(_ctx.addonsData[addon.id].pc, _ctx.addonsData[addon.id].price)), 1), _ctx.addonsData[addon.id].pc.isRecurring ? (_openBlock(), _createElementBlock("div", _hoisted_21, [(_ctx.addonsData[addon.id].timeslots || []).length || _ctx.addonsData[addon.id].chosenTimeslot ? (_openBlock(), _createElementBlock("div", _hoisted_22, [!_ctx.addonsData[addon.id].chosenTimeslot ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "choose-timeslot",
                    ref_for: true,
                    ref: "selectTimeSlot-".concat(addon.id),
                    onClick: function onClick($event) {
                      return _ctx.setShowTimeSlotsModal(true, addon, _ctx.addonsData[addon.id].timeslots || []);
                    }
                  }, _toDisplayString(_ctx.$t("common.select-timeslot")), 9, _hoisted_23)) : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "chosen-timeslot",
                    onClick: function onClick($event) {
                      return _ctx.setShowTimeSlotsModal(true, addon, _ctx.addonsData[addon.id].timeslots || []);
                    }
                  }, [_createTextVNode(_toDisplayString(_ctx.formatDateTime(_ctx.addonsData[addon.id].chosenTimeslot.startDateTime)) + " ", 1), _hoisted_25], 8, _hoisted_24))])) : !_ctx.addonsData[addon.id].chosenTimeslot ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("p", {
                    class: "no-timeslots",
                    ref_for: true,
                    ref: "noTimeSlot-".concat(addon.id)
                  }, _toDisplayString(_ctx.$t("common.no-timeslot")), 513)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])];
                }),
                _: 2
              }, 1024), _createVNode(_component_el_col, {
                span: 9
              }), _createVNode(_component_el_col, {
                span: 6,
                class: "d-flex fl-j-c fl-a-c"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_button, {
                    class: _normalizeClass(["is-fullwidth price-button", {
                      transparent: _ctx.pricesCount[_ctx.addonsData[addon.id].price.id] <= 0
                    }]),
                    type: "primary",
                    size: "large",
                    onClick: function onClick($event) {
                      return _ctx.decrease(_ctx.addonsData[addon.id].price.id);
                    }
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode("- ")];
                    }),
                    _: 2
                  }, 1032, ["class", "onClick"]), _withDirectives(_createElementVNode("input", {
                    style: {
                      "position": "relative"
                    },
                    type: "number",
                    class: "price-count d-flex fl-a-c fl-j-c",
                    "onUpdate:modelValue": function onUpdateModelValue($event) {
                      return _ctx.pricesCount[_ctx.addonsData[addon.id].price.id] = $event;
                    },
                    disabled: _ctx.addonsData[addon.id].pc.isRecurring && !_ctx.addonsData[addon.id].chosenTimeslot
                  }, null, 8, _hoisted_27), [[_vModelText, _ctx.pricesCount[_ctx.addonsData[addon.id].price.id], void 0, {
                    number: true
                  }]]), _ctx.areObjectsEqual(_ctx.priceMaxQuantityLimit(addon, _ctx.addonsData[addon.id].pc, _ctx.addonsData[addon.id].price.id, _ctx.PriceMaxQtyConstraint.EXCEEDED), {
                    maxQtyLimit: true,
                    reason: _ctx.PriceQtyLimitReason.ADDON
                  }) ? (_openBlock(), _createElementBlock("label", _hoisted_28, _toDisplayString(_ctx.$t("error.max-quantity-allowed") + " " + String(addon.maxQuantity)), 1)) : _createCommentVNode("", true), _ctx.priceMinQuantityLimit(addon, _ctx.addonsData[addon.id].pc, _ctx.addonsData[addon.id].price.id) ? (_openBlock(), _createElementBlock("label", _hoisted_29, _toDisplayString(_ctx.$t("error.min-quantity-allowed") + " " + String(addon.minQuantity)), 1)) : _createCommentVNode("", true), addon.isMandatory && _ctx.addonsData[addon.id].pc.isRecurring && !_ctx.addonsData[addon.id].chosenTimeslot ? (_openBlock(), _createElementBlock("label", _hoisted_30, _toDisplayString(_ctx.$t("addons.select-timeslot")), 1)) : _createCommentVNode("", true), _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.addonsData[addon.id].pc.product.currency) + " " + _toDisplayString(((addon.displayedValue || 0) / 100).toFixed(2)), 1), _createElementVNode("div", null, [_createVNode(_component_el_button, {
                    class: _normalizeClass(["is-fullwidth price-button", {
                      transparent: !_ctx.canIncrease(addon, _ctx.addonsData[addon.id].pc, _ctx.addonsData[addon.id].price.id).res
                    }]),
                    type: "primary",
                    size: "large",
                    onClick: function onClick($event) {
                      return _ctx.increase(addon, _ctx.addonsData[addon.id].pc, _ctx.addonsData[addon.id].price.id, index);
                    }
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode("+ ")];
                    }),
                    _: 2
                  }, 1032, ["class", "onClick"])])];
                }),
                _: 2
              }, 1024)];
            }),
            _: 2
          }, 1024)) : _createCommentVNode("", true)]);
        }), 128))]);
      }), 128))])])) : _createCommentVNode("", true), _ctx.timeSlotsModalVisible && _ctx.timeSlotsModalData ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createVNode(_component_el_divider, {
        class: "price-list-divider"
      }), Object.keys(_ctx.timeSlotsModalData.groupedTimeSlots).length ? (_openBlock(), _createElementBlock("div", _hoisted_33, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeSlotsModalData.groupedTimeSlots, function (groupedHours, day, index) {
        return _openBlock(), _createElementBlock("div", {
          class: "select-timeslots-wrapper",
          key: index
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedHours, function (timeslots, hour, index) {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "grouped-hours"
          }, [_createElementVNode("p", _hoisted_34, _toDisplayString(hour), 1), _createElementVNode("ul", _hoisted_35, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeslots, function (timeslot) {
            var _ctx$selectedBooking;

            return _openBlock(), _createElementBlock("li", {
              key: timeslot.id,
              onClick: function onClick($event) {
                return _ctx.chooseTimeSlot({
                  addonId: _ctx.timeSlotsModalData.addon.id,
                  timeslot: timeslot
                });
              }
            }, [_createElementVNode("div", _hoisted_37, [_createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.dayjs(timeslot.startDateTime).format("HH:mm")), 1), _createElementVNode("div", _hoisted_39, [_createElementVNode("p", _hoisted_40, _toDisplayString(timeslot.availability) + " " + _toDisplayString(_ctx.$t("field.tickets-left")), 1), _createElementVNode("p", _hoisted_41, _toDisplayString(((_ctx.timeSlotsModalData.addon.displayedValue || 0) / 100).toFixed(2)) + " " + _toDisplayString((_ctx$selectedBooking = _ctx.selectedBooking) === null || _ctx$selectedBooking === void 0 ? void 0 : _ctx$selectedBooking.currency), 1)])])], 8, _hoisted_36);
          }), 128))])]);
        }), 128))]);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_42, [_createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.$t("common.no-timeslot")), 1)]))])) : _createCommentVNode("", true)];
    }),
    _: 1
  }, 8, ["title", "modelValue"])]);
}